class PredictiveSearch extends SearchForm {
    constructor() {
        super();
        this.cachedResults = {};
        this.predictiveSearchResults = this.querySelector('[data-predictive-search]');
        this.isOpen = false;
        this.abortController = new AbortController();
        this.searchTerm = '';
        this.setupEventListeners();
    }
    get allPredictiveSearchInstances() { return document.querySelectorAll('predictive-search'); }
    setupEventListeners() {
        this.input.form.addEventListener('submit', this.onFormSubmit.bind(this));
        this.input.addEventListener('focus', this.onFocus.bind(this));
        this.addEventListener('focusout', this.onFocusOut.bind(this));
        this.addEventListener('keyup', this.onKeyup.bind(this));
        this.addEventListener('keydown', this.onKeydown.bind(this));
    }
    getQuery() { return this.input.value.trim(); }
    focusSearchInput() {
        if (!this.input)
            return;
        try {
            this.input.focus({ preventScroll: true });
        }
        catch (error) {
            this.input.focus();
        }
        const valueLength = this.input.value.length;
        try {
            this.input.setSelectionRange(valueLength, valueLength);
        }
        catch (error) { }
    }
    onChange() {
        super.onChange();
        const newSearchTerm = this.getQuery();
        if (!this.searchTerm || !newSearchTerm.startsWith(this.searchTerm)) {
            this.querySelector('#predictive-search-results-groups-wrapper')?.remove();
        }
        this.updateSearchForTerm(this.searchTerm, newSearchTerm);
        this.searchTerm = newSearchTerm;
        if (!this.searchTerm.length) {
            this.close(true);
            return;
        }
        this.getSearchResults(this.searchTerm);
    }
    onFormSubmit(event) {
        if (!this.getQuery().length || this.querySelector('[aria-selected="true"] a')) {
            event.preventDefault();
            return;
        }
        this.prepareStorefrontSearchSubmit();
    }
    prepareStorefrontSearchSubmit() {
        const form = this.input?.form;
        if (!form)
            return;
        const ensureHiddenInput = (name, value) => {
            let input = Array.from(form.elements).find((element) => element.name === name);
            if (!input) {
                input = document.createElement('input');
                input.type = 'hidden';
                input.name = name;
                form.appendChild(input);
            }
            input.value = value;
        };
        ensureHiddenInput('type', 'product');
        ensureHiddenInput('options[prefix]', 'last');
        ensureHiddenInput('options[unavailable_products]', 'last');
    }
    onFormReset(event) {
        super.onFormReset(event);
        if (super.shouldResetForm()) {
            this.searchTerm = '';
            this.abortCurrentRequest();
            this.closeResults(true);
            window.CN_updateHeaderSearchResetButton?.(this.closest('details'));
        }
    }
    onFocus() {
        const currentSearchTerm = this.getQuery();
        if (!currentSearchTerm.length)
            return;
        if (this.searchTerm !== currentSearchTerm) {
            this.onChange();
        }
        else if (this.getAttribute('results') === 'true') {
            this.open();
        }
        else {
            this.getSearchResults(this.searchTerm);
        }
    }
    onFocusOut() {
        setTimeout(() => {
            const isMobile = window.matchMedia('(max-width: 749px)').matches;
            const hasSearchTerm = this.input && this.input.value.trim().length > 0;
            if (isMobile && hasSearchTerm && this.getAttribute('results') === 'true') {
                this.open();
                return;
            }
            if (!this.contains(document.activeElement)) {
                this.close();
            }
        });
    }
    onKeyup(event) {
        if (!this.getQuery().length) {
            this.close(true);
        }
        window.CN_updateHeaderSearchResetButton?.(this.closest('details'));
        window.CN_updateMobileSearchGlass?.();
        event.preventDefault();
        switch (event.code) {
            case 'ArrowUp':
                this.switchOption('up');
                break;
            case 'ArrowDown':
                this.switchOption('down');
                break;
            case 'Enter':
                this.selectOption();
                break;
        }
    }
    onKeydown(event) { if (event.code === 'ArrowUp' || event.code === 'ArrowDown') {
        event.preventDefault();
    } }
    updateSearchForTerm(previousTerm, newTerm) {
        const searchForTextElement = this.querySelector('[data-predictive-search-search-for-text]');
        const currentButtonText = searchForTextElement?.innerText;
        if (!currentButtonText)
            return;
        if (previousTerm && currentButtonText.match(new RegExp(previousTerm, 'g'))?.length > 1) {
            return;
        }
        searchForTextElement.innerText = currentButtonText.replace(previousTerm, newTerm);
    }
    switchOption(direction) {
        if (!this.getAttribute('open'))
            return;
        const moveUp = direction === 'up';
        const selectedElement = this.querySelector('[aria-selected="true"]');
        const allVisibleElements = Array.from(this.querySelectorAll('li, button.predictive-search__item')).filter((element) => element.offsetParent !== null);
        let activeElementIndex = 0;
        if (moveUp && !selectedElement)
            return;
        let selectedElementIndex = -1;
        let i = 0;
        while (selectedElementIndex === -1 && i <= allVisibleElements.length) {
            if (allVisibleElements[i] === selectedElement) {
                selectedElementIndex = i;
            }
            i++;
        }
        this.statusElement.textContent = '';
        if (!moveUp && selectedElement) {
            activeElementIndex = selectedElementIndex === allVisibleElements.length - 1 ? 0 : selectedElementIndex + 1;
        }
        else if (moveUp) {
            activeElementIndex = selectedElementIndex === 0 ? allVisibleElements.length - 1 : selectedElementIndex - 1;
        }
        if (activeElementIndex === selectedElementIndex)
            return;
        const activeElement = allVisibleElements[activeElementIndex];
        activeElement.setAttribute('aria-selected', true);
        if (selectedElement) {
            selectedElement.setAttribute('aria-selected', false);
        }
        this.input.setAttribute('aria-activedescendant', activeElement.id);
    }
    selectOption() {
        const selectedOption = this.querySelector('[aria-selected="true"] a, button[aria-selected="true"]');
        if (selectedOption) {
            selectedOption.click();
        }
    }
    abortCurrentRequest() { this.abortController.abort(); this.abortController = new AbortController(); }

    normalizeSearchText(value) {
        return String(value || '')
            .toLowerCase()
            .trim()
            .replace(/ä/g, 'ae')
            .replace(/ö/g, 'oe')
            .replace(/ü/g, 'ue')
            .replace(/ß/g, 'ss');
    }

    buildStorefrontProductQuery(searchTerm) {
        const rawTerm = String(searchTerm || '').trim();

        if (!rawTerm)
            return '';

        /*
          Bei Set-Codes / SKUs die normale Storefront-Suche nicht auf
          den Titel einschränken.
        */
        if (/[0-9-]/.test(rawTerm)) {
            return rawTerm;
        }

        /*
          Für normale Kartennamen erzwingen wir eine Titel-Präfixsuche.
          Beispiel:
          "har"  -> title:har*
          "dunk mag" -> title:dunk* title:mag*
        */
        return rawTerm
            .split(/\s+/)
            .filter(Boolean)
            .map((term) => {
                const cleanedTerm = term.replace(/[\\:*()"']/g, '');
                return cleanedTerm ? `title:${cleanedTerm}*` : '';
            })
            .filter(Boolean)
            .join(' ');
    }

    getStorefrontProductMatchRank(title, searchTerm) {
        const normalizedTitle = this.normalizeSearchText(title);
        const normalizedTerm = this.normalizeSearchText(searchTerm);

        if (!normalizedTitle || !normalizedTerm)
            return 999;

        if (normalizedTitle === normalizedTerm)
            return 0;

        if (normalizedTitle.startsWith(normalizedTerm))
            return 1;

        if (normalizedTitle.includes(normalizedTerm))
            return 2;

        const titleWords = normalizedTitle.split(/[^a-z0-9]+/).filter(Boolean);
        const searchWords = normalizedTerm.split(/[^a-z0-9]+/).filter(Boolean);

        if (
            searchWords.length &&
            searchWords.every((searchWord) =>
                titleWords.some((titleWord) => titleWord.startsWith(searchWord))
            )
        ) {
            return 3;
        }

        return 999;
    }

    prepareStorefrontProductsBlock(productDocument, searchTerm) {
        const sourceBlock = productDocument?.querySelector('#cn-storefront-products-block');

        if (!sourceBlock)
            return null;

        const list = sourceBlock.querySelector('#predictive-search-results-products-list');

        if (!list)
            return null;

        const rankedItems = Array.from(list.querySelectorAll(':scope > li'))
            .map((item) => {
                const title = item.querySelector('.predictive-search__item-heading')?.textContent || '';
                return {
                    item,
                    title,
                    rank: this.getStorefrontProductMatchRank(title, searchTerm),
                };
            })
            .filter((entry) => entry.rank < 999)
            .sort((a, b) => {
                if (a.rank !== b.rank)
                    return a.rank - b.rank;

                return this.normalizeSearchText(a.title).localeCompare(
                    this.normalizeSearchText(b.title),
                    'de',
                    { sensitivity: 'base' }
                );
            })
            .slice(0, 10);

        list.innerHTML = '';

        rankedItems.forEach(({ item }, index) => {
            item.id = `predictive-search-option-product-${index + 1}`;
            list.appendChild(item);
        });

        if (!rankedItems.length)
            return null;

        return sourceBlock;
    }

    mergeStorefrontProducts(predictiveSection, productDocument, searchTerm) {
        const productBlock = this.prepareStorefrontProductsBlock(productDocument, searchTerm);

        /*
          Sobald unser Storefront-Endpunkt erfolgreich vorhanden ist,
          entfernen wir die unzuverlässigen Produktvorschläge aus
          Shopifys Predictive-Search-Antwort.
        */
        const storefrontEndpointExists = !!productDocument?.querySelector('#cn-storefront-product-suggestions');

        if (!storefrontEndpointExists)
            return;

        const existingProductsHeading = predictiveSection.querySelector('#predictive-search-products');
        const existingProductsBlock = existingProductsHeading?.closest('div');
        const existingProductGroup = existingProductsBlock?.closest('.predictive-search__result-group');

        existingProductsBlock?.remove();

        let wrapper = predictiveSection.querySelector('#predictive-search-results-groups-wrapper');

        if (!productBlock) {
            wrapper?.classList.add('predictive-search__results-groups-wrapper--no-products');
            return;
        }

        if (!wrapper) {
            const resultsRoot = predictiveSection.querySelector('#predictive-search-results');

            if (!resultsRoot)
                return;

            wrapper = predictiveSection.ownerDocument.createElement('div');
            wrapper.id = 'predictive-search-results-groups-wrapper';
            wrapper.className =
                'predictive-search__results-groups-wrapper predictive-search__results-groups-wrapper--no-suggestions';

            const loadingState = resultsRoot.querySelector('.predictive-search__loading-state');
            resultsRoot.insertBefore(wrapper, loadingState || resultsRoot.firstChild);
        }

        wrapper.classList.remove('predictive-search__results-groups-wrapper--no-products');

        let targetGroup = existingProductGroup;

        if (!targetGroup || !wrapper.contains(targetGroup)) {
            const groups = Array.from(
                wrapper.querySelectorAll(':scope > .predictive-search__result-group')
            );

            targetGroup = groups[1] || null;
        }

        if (!targetGroup) {
            targetGroup = predictiveSection.ownerDocument.createElement('div');
            targetGroup.className = 'predictive-search__result-group';
            wrapper.appendChild(targetGroup);
        }

        targetGroup.insertBefore(productBlock, targetGroup.firstChild);
    }

    getSearchResults(searchTerm) {
        const queryKey = searchTerm.replace(/\s+/g, '-').toLowerCase();

        this.setLiveRegionLoadingState();

        if (this.cachedResults[queryKey]) {
            this.renderSearchResults(this.cachedResults[queryKey]);
            return;
        }

        this.abortCurrentRequest();

        const predictiveSearchUrl =
            `${routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}` +
            `&resources[type]=product,collection,page,article` +
            `&resources[limit]=10` +
            `&resources[limit_scope]=each` +
            `&resources[options][unavailable_products]=last` +
            `&resources[options][fields]=title,product_type,variants.title,variants.sku,vendor` +
            `&section_id=predictive-search`;

        const storefrontSearchBase =
            routes.search_url ||
            `${window.Shopify?.routes?.root || '/'}search`;

        const storefrontProductQuery = this.buildStorefrontProductQuery(searchTerm);

        const storefrontProductsUrl =
            `${storefrontSearchBase}?q=${encodeURIComponent(storefrontProductQuery)}` +
            `&type=product` +
            `&options[prefix]=last` +
            `&options[unavailable_products]=last` +
            `&view=cn-predictive-products`;

        Promise.all([
            fetch(predictiveSearchUrl, {
                signal: this.abortController.signal,
            }).then((response) => {
                if (!response.ok)
                    throw new Error(`Predictive search: ${response.status}`);

                return response.text();
            }),

            fetch(storefrontProductsUrl, {
                signal: this.abortController.signal,
            }).then((response) => {
                if (!response.ok)
                    throw new Error(`Storefront product search: ${response.status}`);

                return response.text();
            }),
        ])
            .then(([predictiveText, storefrontProductsText]) => {
                const parser = new DOMParser();

                const predictiveDocument = parser.parseFromString(
                    predictiveText,
                    'text/html'
                );

                const predictiveSection =
                    predictiveDocument.querySelector('#shopify-section-predictive-search');

                if (!predictiveSection) {
                    this.close();
                    return;
                }

                const productDocument = parser.parseFromString(
                    storefrontProductsText,
                    'text/html'
                );

                this.mergeStorefrontProducts(
                    predictiveSection,
                    productDocument,
                    searchTerm
                );

                const resultsMarkup = predictiveSection.innerHTML;

                this.allPredictiveSearchInstances.forEach((predictiveSearchInstance) => {
                    predictiveSearchInstance.cachedResults[queryKey] = resultsMarkup;
                });

                this.renderSearchResults(resultsMarkup);
            })
            .catch((error) => {
                if (error?.name === 'AbortError' || error?.code === 20)
                    return;

                this.close();
                console.error('[Cardcomplex predictive search]', error);
            });
    }
    setLiveRegionLoadingState() {
        this.statusElement = this.statusElement || this.querySelector('.predictive-search-status');
        this.loadingText = this.loadingText || this.getAttribute('data-loading-text');
        this.setLiveRegionText(this.loadingText);
        this.setAttribute('loading', true);
    }
    setLiveRegionText(statusText) {
        if (!this.statusElement)
            return;
        this.statusElement.setAttribute('aria-hidden', 'false');
        this.statusElement.textContent = statusText;
        setTimeout(() => {
            this.statusElement.setAttribute('aria-hidden', 'true');
        }, 1000);
    }
    renderSearchResults(resultsMarkup) {
        this.predictiveSearchResults.innerHTML = resultsMarkup;
        this.setAttribute('results', true);
        this.setLiveRegionResults();
        this.open();
    }
    setLiveRegionResults() {
        const countElement = this.querySelector('[data-predictive-search-live-region-count-value]');
        this.removeAttribute('loading');
        this.setLiveRegionText(countElement?.textContent || '');
    }
    getResultsMaxHeight() {
        const sectionHeader = document.querySelector('.section-header');
        const headerBottom = sectionHeader?.getBoundingClientRect().bottom || 0;
        const height = Math.max(160, window.innerHeight - headerBottom);
        this.resultsMaxHeight = `${height}px`;
        return this.resultsMaxHeight;
    }
    open() {
        const glassPanel = this.querySelector('.cn-predictive-search-glass');
        this.predictiveSearchResults.style.maxHeight = this.resultsMaxHeight || this.getResultsMaxHeight();
        if (glassPanel) {
            glassPanel.setAttribute('aria-hidden', 'false');
        }
        this.setAttribute('open', true);
        this.input.setAttribute('aria-expanded', true);
        this.isOpen = true;
        requestAnimationFrame(() => {
            window.CN_updateMobileSearchGlass?.();
            window.CN_updateTabletSearchResultsUnderlay?.();
        });
    }
    close(clearSearchTerm = false) { this.closeResults(clearSearchTerm); this.isOpen = false; }
    closeResults(clearSearchTerm = false) {
        if (clearSearchTerm) {
            this.input.value = '';
            this.searchTerm = '';
            this.removeAttribute('results');
        }
        const selected = this.querySelector('[aria-selected="true"]');
        if (selected) {
            selected.setAttribute('aria-selected', false);
        }
        this.input.setAttribute('aria-activedescendant', '');
        this.input.setAttribute('aria-expanded', false);
        this.removeAttribute('loading');
        this.removeAttribute('open');
        const glassPanel = this.querySelector('.cn-predictive-search-glass');
        if (glassPanel) {
            glassPanel.setAttribute('aria-hidden', 'true');
        }
        window.CN_clearMobileSearchGlass?.();
        this.resultsMaxHeight = false;
        this.predictiveSearchResults.removeAttribute('style');
    }
}
if (!customElements.get('predictive-search')) {
    customElements.define('predictive-search', PredictiveSearch);
}
(() => {
    if (window.cnHeaderSearchEnhancementsBound)
        return;
    window.cnHeaderSearchEnhancementsBound = true;
    const mobileQuery = window.matchMedia('(max-width: 749px)');
    const drawerQuery = window.matchMedia('(max-width: 989px)');
    const removeOldMobileLayers = () => { document.querySelectorAll('body > .cn-mobile-search-real-underlay, ' + 'body > .cn-mobile-search-result-border-layer, ' + 'body > .cn-mobile-search-glass-layer').forEach((layer) => layer.remove()); };
    const closeHeaderDrawer = () => {
        if (!drawerQuery.matches)
            return;
        const openDrawerDetails = document.querySelectorAll('header-drawer details[open], details.menu-drawer-container[open]');
        if (!openDrawerDetails.length)
            return;
        openDrawerDetails.forEach((drawerDetails) => {
            const headerDrawer = drawerDetails.closest('header-drawer');
            try {
                headerDrawer?.closeMenuDrawer?.(new Event('cn-search-open'), false);
            }
            catch (error) { }
            drawerDetails.classList.remove('menu-opening');
            drawerDetails.querySelectorAll('details[open]').forEach((nestedDetails) => {
                nestedDetails.classList.remove('menu-opening');
                nestedDetails.removeAttribute('open');
            });
            drawerDetails.querySelectorAll('.submenu-open').forEach((submenu) => {
                submenu.classList.remove('submenu-open');
            });
            drawerDetails.querySelectorAll('[aria-expanded="true"]').forEach((element) => {
                element.setAttribute('aria-expanded', 'false');
            });
            const menuSummary = drawerDetails.querySelector('summary.header__icon--menu, summary');
            menuSummary?.setAttribute('aria-expanded', 'false');
            drawerDetails.removeAttribute('open');
        });
        document.documentElement.classList.remove('overflow-hidden', 'overflow-hidden-mobile', 'overflow-hidden-tablet', 'cn-drawer-open', 'cn-header-drawer-open');
        document.body.classList.remove('overflow-hidden', 'overflow-hidden-mobile', 'overflow-hidden-tablet', 'cn-drawer-open', 'cn-header-drawer-open');
    };
    window.CN_closeHeaderDrawer = closeHeaderDrawer;
    const getPredictiveSearch = (details) => details?.querySelector('predictive-search');
    const getSearchInput = (details) => details?.querySelector('input[type="search"][name="q"]');
    const getMobileSearchGlassLayer = (searchModal) => {
        if (!searchModal)
            return null;
        let layer = Array.from(searchModal.children).find((child) => child.classList?.contains('cn-mobile-search-glass-layer'));
        if (!layer) {
            layer = document.createElement('div');
            layer.className = 'cn-mobile-search-glass-layer';
            layer.setAttribute('aria-hidden', 'true');
            searchModal.insertBefore(layer, searchModal.firstElementChild);
        }
        return layer;
    };
    const clearMobileSearchGlass = () => {
        removeOldMobileLayers();
        document.querySelectorAll('.header__search .search-modal > .cn-mobile-search-glass-layer').forEach((layer) => {
            layer.classList.remove('is-active');
            layer.style.removeProperty('--cn-mobile-search-glass-top');
            layer.style.removeProperty('--cn-mobile-search-glass-left');
            layer.style.removeProperty('--cn-mobile-search-glass-width');
            layer.style.removeProperty('--cn-mobile-search-glass-height');
        });
        document.querySelectorAll('.header__search .cn-predictive-search-glass').forEach((glassPanel) => {
            glassPanel.style.removeProperty('--cn-mobile-search-max-height');
            glassPanel.setAttribute('aria-hidden', 'true');
        });
    };
    const updateMobileSearchGlass = () => {
        removeOldMobileLayers();
        if (!mobileQuery.matches) {
            clearMobileSearchGlass();
            return;
        }
        const openPredictiveSearch = document.querySelector('.header__search details[open] predictive-search[open]');
        const glassPanel = openPredictiveSearch?.querySelector('.cn-predictive-search-glass');
        const searchModal = openPredictiveSearch?.closest('.search-modal');
        if (!openPredictiveSearch || !glassPanel || !searchModal) {
            clearMobileSearchGlass();
            return;
        }
        const modalRect = searchModal.getBoundingClientRect();
        const estimatedTop = modalRect.bottom + 2;
        const maxHeight = Math.max(180, window.innerHeight - estimatedTop - 16);
        glassPanel.style.setProperty('--cn-mobile-search-max-height', `${Math.round(maxHeight)}px`);
        glassPanel.setAttribute('aria-hidden', 'false');
        const glassRect = glassPanel.getBoundingClientRect();
        if (glassRect.width < 2 || glassRect.height < 2) {
            requestAnimationFrame(updateMobileSearchGlass);
            return;
        }
        const layer = getMobileSearchGlassLayer(searchModal);
        if (!layer)
            return;
        layer.style.setProperty('--cn-mobile-search-glass-top', `${Math.round(glassRect.top - modalRect.top)}px`);
        layer.style.setProperty('--cn-mobile-search-glass-left', `${Math.round(glassRect.left - modalRect.left)}px`);
        layer.style.setProperty('--cn-mobile-search-glass-width', `${Math.round(glassRect.width)}px`);
        layer.style.setProperty('--cn-mobile-search-glass-height', `${Math.round(glassRect.height)}px`);
        layer.classList.add('is-active');
    };
    window.CN_updateMobileSearchGlass = updateMobileSearchGlass;
    window.CN_clearMobileSearchGlass = clearMobileSearchGlass;
    const setSearchState = (details) => {
        if (!details)
            return;
        const header = details.closest('.header');
        const isOpen = details.open;
        header?.classList.toggle('cn-search-open', isOpen);
        document.body.classList.toggle('cn-search-open', isOpen);
        if (!isOpen) {
            clearMobileSearchGlass();
        }
    };
    const updateResetButton = (details) => {
        const searchInput = getSearchInput(details);
        const resetButton = details?.querySelector('.reset__button');
        if (!searchInput || !resetButton)
            return;
        resetButton.classList.toggle('hidden', searchInput.value.trim().length === 0);
    };
    window.CN_updateHeaderSearchResetButton = updateResetButton;
    const focusSearchInput = (details) => {
        const predictiveSearch = getPredictiveSearch(details);
        const searchInput = getSearchInput(details);
        if (predictiveSearch?.focusSearchInput) {
            predictiveSearch.focusSearchInput();
            return;
        }
        if (!searchInput)
            return;
        try {
            searchInput.focus({ preventScroll: true });
        }
        catch (error) {
            searchInput.focus();
        }
    };
    const clearSearchState = (details) => {
        const searchInput = getSearchInput(details);
        const predictiveResults = details?.querySelector('[data-predictive-search]');
        const predictiveStatus = details?.querySelector('.predictive-search-status');
        const predictiveSearch = getPredictiveSearch(details);
        if (searchInput) {
            searchInput.value = '';
            searchInput.setAttribute('value', '');
            searchInput.setAttribute('aria-expanded', 'false');
            searchInput.setAttribute('aria-activedescendant', '');
        }
        updateResetButton(details);
        if (predictiveSearch) {
            predictiveSearch.searchTerm = '';
            predictiveSearch.closeResults?.(true);
        }
        if (predictiveResults) {
            predictiveResults.removeAttribute('results');
            predictiveResults.setAttribute('aria-hidden', 'true');
            predictiveResults.removeAttribute('style');
        }
        if (predictiveStatus) {
            predictiveStatus.textContent = '';
            predictiveStatus.setAttribute('aria-hidden', 'true');
        }
        clearMobileSearchGlass();
    };
    const closeHeaderSearch = (details, clear = false) => {
        if (!details)
            return;
        const predictiveSearch = getPredictiveSearch(details);
        if (clear) {
            clearSearchState(details);
        }
        else {
            predictiveSearch?.close?.();
        }
        details.removeAttribute('open');
        setSearchState(details);
        clearMobileSearchGlass();
    };
    const closeOtherHeaderSearches = (currentDetails) => { document.querySelectorAll('.header__search details[open]').forEach((openDetails) => { if (openDetails !== currentDetails) {
        closeHeaderSearch(openDetails, true);
    } }); };
    const openHeaderSearchFromGesture = (details) => {
        if (!details)
            return;
        closeHeaderDrawer();
        closeOtherHeaderSearches(details);
        if (!details.open) {
            details.setAttribute('open', '');
        }
        setSearchState(details);
        if (mobileQuery.matches) {
            clearSearchState(details);
        }
        focusSearchInput(details);
        requestAnimationFrame(() => {
            setSearchState(details);
            updateResetButton(details);
            focusSearchInput(details);
            updateMobileSearchGlass();
        });
    };
    document.addEventListener('pointerdown', (event) => {
        if (!mobileQuery.matches)
            return;
        const searchTrigger = event.target.closest('.header__search summary');
        if (searchTrigger) {
            const details = searchTrigger.closest('details');
            event.preventDefault();
            event.stopPropagation();
            if (typeof event.stopImmediatePropagation === 'function') {
                event.stopImmediatePropagation();
            }
            openHeaderSearchFromGesture(details);
            return;
        }
        const openDetails = document.querySelector('.header__search details[open]');
        if (!openDetails)
            return;
        if (openDetails.contains(event.target))
            return;
        if (event.target.closest('.header__icon--search, summary[aria-haspopup="dialog"]'))
            return;
        closeHeaderSearch(openDetails);
    }, true);
    document.addEventListener('touchstart', (event) => {
        if (!mobileQuery.matches)
            return;
        const searchTrigger = event.target.closest('.header__search summary');
        if (!searchTrigger)
            return;
        const details = searchTrigger.closest('details');
        event.preventDefault();
        event.stopPropagation();
        openHeaderSearchFromGesture(details);
    }, { capture: true, passive: false });
    document.addEventListener('toggle', (event) => {
        const details = event.target;
        if (!(details instanceof HTMLDetailsElement))
            return;
        if (!details.closest('.header__search'))
            return;
        if (details.open) {
            closeHeaderDrawer();
        }
        closeOtherHeaderSearches(details);
        setSearchState(details);
        if (!details.open) {
            clearMobileSearchGlass();
            return;
        }
        if (mobileQuery.matches) {
            requestAnimationFrame(() => {
                updateResetButton(details);
                focusSearchInput(details);
                updateMobileSearchGlass();
            });
        }
        else {
            requestAnimationFrame(() => focusSearchInput(details));
        }
    }, true);
    document.addEventListener('click', (event) => {
        const closeButton = event.target.closest('[data-cn-search-close]');
        if (closeButton) {
            const details = closeButton.closest('details');
            event.preventDefault();
            event.stopPropagation();
            closeHeaderSearch(details, true);
            return;
        }
        const searchTrigger = event.target.closest('.header__search summary');
        if (!searchTrigger)
            return;
        const details = searchTrigger.closest('details');
        closeHeaderDrawer();
        if (mobileQuery.matches) {
            event.preventDefault();
            event.stopPropagation();
            openHeaderSearchFromGesture(details);
            return;
        }
        requestAnimationFrame(() => {
            if (!details?.open)
                return;
            setSearchState(details);
            focusSearchInput(details);
        });
    }, true);
    document.addEventListener('input', (event) => {
        const searchInput = event.target.closest('.header__search input[type="search"][name="q"]');
        if (!searchInput)
            return;
        updateResetButton(searchInput.closest('details'));
        requestAnimationFrame(updateMobileSearchGlass);
    }, true);
    document.addEventListener('submit', (event) => {
        const form = event.target.closest('form[action*="/search"]');
        if (!form)
            return;
        const searchInput = form.querySelector('input[type="search"][name="q"]');
        if (!searchInput)
            return;
        const rawSearchTerm = searchInput.value.trim();
        if (!rawSearchTerm)
            return;
        /* Spezielle Shopify-Syntax nicht anfassen. */
        if (rawSearchTerm.includes(':') || rawSearchTerm.includes('*') || rawSearchTerm.includes('"')) {
            return;
        }
        /* Set-Codes / SKUs nicht mit * verändern: LDS2-DE075, RA01-DE073 usw. */
        if (/[0-9-]/.test(rawSearchTerm))
            return;
        const terms = rawSearchTerm.split(/\s+/).filter(Boolean);
        if (!terms.length)
            return;
        terms[terms.length - 1] = `${terms[terms.length - 1]}*`;
        searchInput.value = terms.join(' ');
    }, true);
    window.addEventListener('resize', () => window.CN_updateMobileSearchGlass?.(), { passive: true });
    window.visualViewport?.addEventListener('resize', () => window.CN_updateMobileSearchGlass?.(), { passive: true });
    removeOldMobileLayers();
})();
(() => {
    if (window.cnTabletSearchResultsUnderlayBound)
        return;

    window.cnTabletSearchResultsUnderlayBound = true;

    const tabletQuery = window.matchMedia('(min-width: 750px) and (max-width: 999px)');
    const rootSelector = '.header__search';

    let frameId = 0;
    let timeoutOne = 0;
    let timeoutTwo = 0;
    let timeoutThree = 0;

    const getUnderlay = () => {
        let layer = document.querySelector('body > .cn-tablet-search-results-underlay');

        if (!layer) {
            layer = document.createElement('div');
            layer.className = 'cn-tablet-search-results-underlay';
            layer.setAttribute('aria-hidden', 'true');
            document.body.appendChild(layer);
        }

        return layer;
    };

    const clearUnderlay = () => {
        const layer = document.querySelector('body > .cn-tablet-search-results-underlay');

        if (!layer)
            return;

        layer.classList.remove('is-active');
        layer.style.removeProperty('--cn-tablet-search-underlay-top');
        layer.style.removeProperty('--cn-tablet-search-underlay-left');
        layer.style.removeProperty('--cn-tablet-search-underlay-width');
        layer.style.removeProperty('--cn-tablet-search-underlay-height');
    };

    const getResultsBox = () => {
        return document.querySelector(
            '.header__search details[open] predictive-search[open] .predictive-search--header, ' +
            '.header__search details[open] predictive-search[open] [data-predictive-search], ' +
            '.header__search details[open] predictive-search[open] .predictive-search'
        );
    };

    const updateUnderlay = () => {
        if (!tabletQuery.matches || !document.body.classList.contains('cn-search-open')) {
            clearUnderlay();
            return;
        }

        const resultsBox = getResultsBox();

        if (!resultsBox) {
            clearUnderlay();
            return;
        }

        const rect = resultsBox.getBoundingClientRect();
        const style = window.getComputedStyle(resultsBox);

        if (
            rect.width < 2 ||
            rect.height < 2 ||
            style.display === 'none' ||
            style.visibility === 'hidden' ||
            style.opacity === '0'
        ) {
            clearUnderlay();
            return;
        }

        const layer = getUnderlay();

        layer.style.setProperty('--cn-tablet-search-underlay-top', `${Math.round(rect.top)}px`);
        layer.style.setProperty('--cn-tablet-search-underlay-left', `${Math.round(rect.left)}px`);
        layer.style.setProperty('--cn-tablet-search-underlay-width', `${Math.round(rect.width)}px`);
        layer.style.setProperty('--cn-tablet-search-underlay-height', `${Math.round(rect.height)}px`);

        layer.classList.add('is-active');

        /*
          Safari rendert backdrop-filter nach frischem Page Load manchmal erst
          nach einem Repaint. Diese zwei Zeilen erzwingen genau diesen Repaint,
          ohne Layout oder Position sichtbar zu verändern.
        */
        layer.style.webkitTransform = 'translateZ(0) scale(1.0001)';
        layer.offsetHeight;
        layer.style.webkitTransform = 'translateZ(0)';
    };

    const scheduleUpdate = () => {
        window.cancelAnimationFrame(frameId);
        window.clearTimeout(timeoutOne);
        window.clearTimeout(timeoutTwo);
        window.clearTimeout(timeoutThree);

        frameId = window.requestAnimationFrame(() => {
            updateUnderlay();
            window.requestAnimationFrame(updateUnderlay);
        });

        timeoutOne = window.setTimeout(updateUnderlay, 80);
        timeoutTwo = window.setTimeout(updateUnderlay, 180);
        timeoutThree = window.setTimeout(updateUnderlay, 420);
    };

    window.CN_updateTabletSearchResultsUnderlay = scheduleUpdate;
    window.CN_clearTabletSearchResultsUnderlay = clearUnderlay;

    const shouldScheduleFromEvent = (event) => {
        return !!event.target?.closest?.(rootSelector);
    };

    document.addEventListener(
        'input',
        (event) => {
            if (!shouldScheduleFromEvent(event))
                return;

            scheduleUpdate();
        },
        true
    );

    document.addEventListener(
        'keyup',
        (event) => {
            if (!shouldScheduleFromEvent(event))
                return;

            scheduleUpdate();
        },
        true
    );

    document.addEventListener(
        'focusin',
        (event) => {
            if (!shouldScheduleFromEvent(event))
                return;

            scheduleUpdate();
        },
        true
    );

    document.addEventListener(
        'toggle',
        (event) => {
            if (!(event.target instanceof HTMLDetailsElement))
                return;

            if (!event.target.closest(rootSelector))
                return;

            if (event.target.open) {
                scheduleUpdate();
            } else {
                clearUnderlay();
            }
        },
        true
    );

    document.addEventListener(
        'click',
        (event) => {
            if (event.target.closest('[data-cn-search-close], .search-modal__close-button')) {
                clearUnderlay();
                return;
            }

            if (!shouldScheduleFromEvent(event))
                return;

            scheduleUpdate();
        },
        true
    );

    const bindSearchObservers = () => {
        document.querySelectorAll(rootSelector).forEach((searchRoot) => {
            if (searchRoot.dataset.cnTabletUnderlayObserver === 'true')
                return;

            searchRoot.dataset.cnTabletUnderlayObserver = 'true';

            const observer = new MutationObserver(() => {
                if (!tabletQuery.matches || !document.body.classList.contains('cn-search-open'))
                    return;

                scheduleUpdate();
            });

            observer.observe(searchRoot, {
                childList: true,
                subtree: true,
                attributes: true,
                attributeFilter: ['open', 'style', 'class', 'results', 'loading', 'aria-hidden'],
            });
        });
    };

    bindSearchObservers();

    document.addEventListener('DOMContentLoaded', () => {
        bindSearchObservers();
        scheduleUpdate();
    });

    window.addEventListener('load', scheduleUpdate, { passive: true });
    window.addEventListener('resize', scheduleUpdate, { passive: true });
    window.addEventListener('scroll', scheduleUpdate, { passive: true });
    window.visualViewport?.addEventListener('resize', scheduleUpdate, { passive: true });
})();

